import React, { useEffect, useState, useCallback } from "react";
import { IconApp } from "./IconApp";
import { useSelector } from "react-redux";

const PX_PER_LEVEL = {
    0: "0px",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "48px",
};

const SidebarNavAccordion = ({
    itemLevel,
    title,
    iconLeftClassName,
    children,
}) => {
    const { minimized } = useSelector((s) => s.sidebar);
    const { uiShowModulesCount } = useSelector((s) => s.ui);
    const [isShow, setIsShow] = useState(false);

    const hasChildren = Array.isArray(children)
        ? children.filter(Boolean).length > 0
        : !!children;
    if (!hasChildren) return null;

    useEffect(() => {
        setIsShow(uiShowModulesCount.length <= 3);
    }, [uiShowModulesCount]);

    const toggle = useCallback((e) => {
        // Evita que el click “salga” del header y cierre el offcanvas,
        // pero no hacemos preventDefault para no romper otros handlers.
        e.stopPropagation();
        setIsShow((s) => !s);
    }, []);

    // Espaciados dependientes del estado minimizado
    const PADDING_Y = minimized ? 12 : 12;
    const PADDING_X = minimized ? 0 : 8;
    const GRID_GAP = minimized ? 8 : 10;

    // En minimizado sólo mostramos icono y chevron; ocultamos texto para no romper el ancho
    const gridTemplateColumns = minimized ? "1fr 0px 18px" : "24px 1fr 18px";
    const titleLeft = minimized ? 0 : 6;
    const leftIndent = minimized ? "8px" : PX_PER_LEVEL[itemLevel];

    return (
        <div>
            <button
                type="button"
                className="c-sidebar-nav-link nav-submenu-trigger"
                onClick={toggle}
                style={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns,
                    alignItems: "center",
                    columnGap: GRID_GAP,
                    padding: `${PADDING_Y}px ${PADDING_X}px`,
                    background: "transparent",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer",
                    position: "relative",
                    lineHeight: 1.2,
                }}
            >
                <span
                    style={{
                        marginLeft: leftIndent,
                        width: minimized ? "100%" : "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: 24,
                    }}
                >
                    <IconApp
                        iconClassName={iconLeftClassName}
                        isClickable={false}
                    />
                </span>

                {/* En minimizado ocultamos el título visualmente para no chocar con el minimizer */}
                {minimized ? (
                    <span aria-hidden="true" />
                ) : (
                    <strong style={{ marginLeft: titleLeft, fontWeight: 600 }}>
                        {title}
                    </strong>
                )}

                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: "-10px",
                    }}
                >
                    <IconApp
                        iconClassName={
                            isShow
                                ? "fa-solid fa-angle-down c-sidebar-nav-icon"
                                : "fa-solid fa-angle-right c-sidebar-nav-icon"
                        }
                        isClickable={false}
                    />
                </span>
            </button>

            <div
                className="nav-menu-item"
                style={{
                    marginLeft: leftIndent,
                    paddingLeft: minimized ? 0 : 8,
                    paddingTop: minimized ? 2 : 4,
                }}
            >
                {isShow && children}
            </div>
        </div>
    );
};

export default SidebarNavAccordion;
